import { PropTypes } from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HandleClickOutside } from '../../../../common/HandleClickOutside'
import { UseTheme } from '../../../../common/hooks/useTheme'
import { UseTypeFontSize } from '../../../../common/hooks/useTypeFontSize'
import { Element } from '../../../../common/html/element'
import { getStyle } from '../../../../common/html/helper'
import { Icon } from '../../../../common/html/icon'
import { IGNORE_CHARACTER, MAX_INPUT_LENGTH } from '../../common/constant'
import { changeAlertPopup } from '../../common/store/slice'
import { saveCriteria } from '../../common/store/thunk'
import {
  changeCriteriaData,
  selectLoading,
  selectSelectedCriteria,
} from '../store/slice'
import classes from './index.module.scss'

export const EditName = ({ name, closeEdit, inputStyle }) => {
  const dispatch = useDispatch()
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()

  const isLoadingGetCriteria = useSelector(selectLoading('selectedCriteria'))
  const selectedCriteria = useSelector(selectSelectedCriteria())

  const [editName, setEditName] = useState(name)

  const onChangeName = (e) => {
    const value = e.target.value
      .slice(0, MAX_INPUT_LENGTH)
      .split('')
      .filter((c) => !IGNORE_CHARACTER.includes(c))
      .join('')
    setEditName(value)
  }

  const handleUpdateName = () => {
    const value = editName.trim()
    if (isLoadingGetCriteria || !value) return
    if (value === name) {
      closeEdit()
      return
    }

    dispatch(
      saveCriteria({
        id: selectedCriteria.id,
        name: value,
        parameters: selectedCriteria.parameters,
        screeningCriteria: null,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeCriteriaData({
            id: selectedCriteria.id,
            key: 'screeningSavedCriteriaName',
            value,
          }),
        )
        dispatch(
          changeCriteriaData({
            id: selectedCriteria.id,
            key: 'updateDate',
            value: new Date().toISOString(),
          }),
        )
        closeEdit()
      })
      .catch((error) => {
        dispatch(
          changeAlertPopup({
            isShow: true,
            title: 'screening.WARNING',
            message: error,
            isI18n: false,
          }),
        )
      })
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleUpdateName()
    }
    if (e.key === 'Escape') {
      closeEdit()
    }
  }

  return (
    <Element className="flex1 minW0">
      <HandleClickOutside handleClickOutside={closeEdit}>
        <Element
          className={classes.editName}
          style={{ borderColor: '#2C73E8' }}
        >
          <input
            value={editName}
            onChange={onChangeName}
            autoFocus
            onFocus={(e) => e.target.select()}
            onKeyDown={onKeyDown}
            style={getStyle({ ...inputStyle }, theme, typeFontSize)}
          />
          <Element className={classes.actionButtons}>
            <Element className={classes.button} onClick={closeEdit}>
              <Icon
                className="icon-delete"
                style={{ fontSize: 9, color: '#9C9C9C' }}
              />
            </Element>
            <Element className={classes.button} onClick={handleUpdateName}>
              <Icon
                className="icon-tick cursorPointer"
                style={{ fontSize: 11, color: '#3DA967' }}
              />
            </Element>
          </Element>
        </Element>
      </HandleClickOutside>
    </Element>
  )
}

EditName.propTypes = {
  name: PropTypes.string.isRequired,
  closeEdit: PropTypes.func,
  inputStyle: PropTypes.object,
}

EditName.defaultProps = {
  inputStyle: {},
  closeEdit: () => {},
}
